export default {
  search: {
    placeholder: 'Type a keyword...',
  },
  sort: {
    sortAsc: 'Sort column ascending',
    sortDesc: 'Sort column descending',
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
    navigate: (page, pages) => `Page ${page} of ${pages}`,
    page: (page) => `Page ${page}`,
    showing: 'Showing',
    of: 'of',
    to: 'to',
    results: 'results',
  },
  loading: 'Loading...Please wait...',
  noRecordsFound: 'No matching records found',
  error: 'No matching records found',
};
